import { GET_CURRENT_SHIP } from './../constants/actionTypes'

const ship = (store = '', action = {}) => {
  switch (action.type) {
    case GET_CURRENT_SHIP:
      return action.data
    default:
      return store
  }
}

export default ship
